// Copyright © Veeam Software Group GmbH

import type { RESTRestorePoint } from 'api/rxjs';

export function filterRestorePointsByDate(date: Date, restorePoints: RESTRestorePoint[]): RESTRestorePoint[] {
    if (!date) return [];

    return restorePoints.filter(point => new Date(point.backupTime).toLocaleDateString() === date.toLocaleDateString());
}
